import React, { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";
import ephLogo from "../../images/logo-min.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import { AppContext } from "../../contexts/AppContext";
import { UrlContext } from "../../contexts/UrlContext";

export default function AddToProject({ expertID, btnName }) {
  const [addToProjectPopup, setAddToProjectPopup] = useState(false);
  const [projects, setProjects] = useState([]);
  const [customisedLists, setCustomisedLists] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [selectedListId, setSelectedListId] = useState("");
  const [loading, setLoading] = useState(false);
  const tokenObj = localStorage.getItem("eph-token");
  const token = JSON.parse(tokenObj).value;
  const { API_URL } = useContext(UrlContext);
  const { allProjects } = useContext(AppContext);
  useEffect(() => {
    setProjects(allProjects);
  }, [allProjects]);

  const { allCustomisedLists } = useContext(AppContext);
  useEffect(() => {
    setCustomisedLists(allCustomisedLists);
  }, [allCustomisedLists]);

  const isButtonDisabled = !selectedProjectId && !selectedListId;

  const addToPrjHandler = () => {
    setLoading(true);
    let projectID = null;
    let cListID = null;
    if (selectedProjectId && selectedListId) {
      projectID = projects.find(
        (project) => project.zoho_id + "-" + project.clientName + " - " + project.name === selectedProjectId
      ).id;
      cListID = customisedLists.find(
        (customisedList) =>
          customisedList.clID + "-" + customisedList.name === selectedListId
      ).id;
    } else if (selectedProjectId) {
      projectID = projects.find(
        (project) => project.zoho_id + "-" + project.clientName + " - "+ project.name === selectedProjectId
      ).id;
    } else {
      cListID = customisedLists.find(
        (customisedList) =>
          customisedList.clID + "-" + customisedList.name === selectedListId
      ).id;
    }
    const url = `${API_URL}add-from-profile`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        expertID,
        projectID,
        cListID,
        ephToken: token
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setAddToProjectPopup(false);
        setLoading(false);
        if (data.status === "success") {
          Swal.fire({
            title: "Success!",
            text: data.msg,
            icon: "success",
            confirmButtonText: "OK",
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: "Something went wrong!",
            icon: "error",
          });
        }
      })
      .catch((err) => {
        setAddToProjectPopup(false);
        setLoading(false);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong!",
          icon: "error",
        });
      });
  };

  return (
    <>
      <button
        className="btn addToPjButton"
        onClick={() => setAddToProjectPopup(true)}
      >
        {" "}
        {btnName} {"  "}
        <i className="fa-solid fa-user-plus" />
      </button>

      {addToProjectPopup && (
        <div className="addToProject-popup-wrapper">
          <div className="tab-pane fade show addToPj-div">
            {!loading ? (
              <>
                <div className="mb-3">
                  <center>
                    <img className="image" height="50px" src={ephLogo} alt="" />
                    <p className="mb-2">
                      Select a Project/Customized List and press confirm!
                    </p>
                    <div>
                      <input
                        list="allProjects"
                        id="addExpert"
                        placeholder="Search for project"
                        onChange={(e) => setSelectedProjectId(e.target.value)}
                        value={selectedProjectId}
                      />
                      <datalist id="allProjects">
                        {projects?.map((project) => (
                          <option
                            key={project.id}
                            data-value={project.id}
                            value={project.zoho_id + "-" + project.clientName + ' - ' + project.name}
                          />
                        ))}
                      </datalist>
                    </div>

                    <div>
                      <input
                        list="allCustomisedLists"
                        id="addExpertTOList"
                        placeholder="Search for customized list"
                        onChange={(e) => setSelectedListId(e.target.value)}
                        value={selectedListId}
                      />
                      <datalist id="allCustomisedLists">
                        {customisedLists?.map((customisedList) => (
                          <option
                            key={customisedList.clID}
                            data-value={customisedList.clID}
                            value={
                              customisedList.clID + "-" + customisedList.name
                            }
                          />
                        ))}
                      </datalist>
                    </div>
                  </center>
                </div>
                <div>
                  <center>
                    <button
                      className="btn btn-light"
                      onClick={() => setAddToProjectPopup(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn base-btn addToPjBtn"
                      disabled={isButtonDisabled}
                      onClick={addToPrjHandler}
                      style={{ marginLeft: "6px" }}
                    >
                      Confirm
                    </button>
                  </center>
                </div>
              </>
            ) : (
              <center>
                <p style={{ fontSize: "18px" }}>
                  Adding profile to project . . .
                </p>
                <br />
                <img
                  src={LoadingIcon}
                  alt=""
                  style={{
                    width: "50px",
                    marginRight: "5px",
                    marginBottom: "20px",
                  }}
                />
              </center>
            )}
          </div>
        </div>
      )}
    </>
  );
}
